import script from "./CertificationDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificationDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./CertificationDropdown.vue?vue&type=style&index=0&id=3e5c3370&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e5c3370"]])

export default __exports__